const URL_PLACEHOLDER_REGEX = /\{\{(\w+)\}\}|%7B%7B(\w+)%7D%7D/g

export function interpolateUrlPlaceholders(
  url: string,
  values: Record<string, string | undefined>,
): string {
  return url.replace(URL_PLACEHOLDER_REGEX, (match, plainName?: string, encodedName?: string) => {
    const name = plainName ?? encodedName

    if (!name || !(name in values)) {
      return match
    }

    const value = values[name]

    return value ? encodeURIComponent(value) : ''
  })
}
